import * as React from "react";
const SvgFiRrShippingFast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 5h-2.077a5 5 0 0 0-3.674-3.968.999.999 0 1 0-.498 1.936A3 3 0 0 1 15 5.874V17H4c-1.103 0-2-.897-2-2v-4h2.5a1 1 0 1 0 0-2H2c-1.103 0-2 .897-2 2v4a4.01 4.01 0 0 0 3.055 3.887A3.504 3.504 0 0 0 6.5 23a3.504 3.504 0 0 0 3.463-4h4.074a3.504 3.504 0 0 0 3.463 4 3.504 3.504 0 0 0 3.445-4.113A4.01 4.01 0 0 0 24 15v-5c0-2.757-2.243-5-5-5m3 5v1h-5V7h2c1.654 0 3 1.346 3 3M8 19.5c0 .827-.673 1.5-1.5 1.5S5 20.327 5 19.5c0-.189.037-.356.091-.5H7.91c.054.144.091.311.091.5zm9.5 1.5c-.827 0-1.5-.673-1.5-1.5 0-.189.037-.356.091-.5h2.819c.054.144.091.311.091.5 0 .827-.674 1.5-1.501 1.5m2.5-4h-3v-4h5v2c0 1.103-.897 2-2 2M0 2a1 1 0 0 1 1-1h8.154a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6.154a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1"
    />
  </svg>
);
export default SvgFiRrShippingFast;
